/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {MaterialDetailContract} from './contracts/material-detail/model/material-detail.contract';

@Injectable({
    providedIn: 'root'
})
export class MaterialApi {

    // API endpoints
    materialBaseUrl = `${environment.partNumberChangesBaseUrl}/api/material`;
    materialDetailUrl = `${this.materialBaseUrl}/detail`;
    materialDetailAiUrl = `${this.materialBaseUrl}/detail/ai`;
    materialDetailActiveUrl = `${this.materialDetailUrl}/active`;
    materialDetailAiActiveUrl = `${this.materialDetailUrl}/ai/active`;

    constructor(protected http: HttpClient) {
    }

    /**
     * This method retrieves all materials by number or description and supplying packing plant
     * @param numberOrDescription the number or description
     * @param supplyingPackingPlantCode supplying packing plant code
     * @param firstResult The first result
     * @param maxResults The max result
     */
    getAllMaterials(numberOrDescription: string,
                    supplyingPackingPlantCode: string,
                    firstResult: number,
                    maxResults: number): Observable<MaterialDetailContract[]> {
        return this.http.get<MaterialDetailContract[]>(`${this.materialDetailUrl}?` + [
            `numberOrDescription=${numberOrDescription}`,
            `supplyingPackingPlantCode=${supplyingPackingPlantCode}`,
            `firstResult=${firstResult}`,
            `maxResults=${maxResults}`
        ].join(('&')));
    }

    /**
     * This method retrieves the active materials by number or description and supplying packing plant
     * @param numberOrDescription the number or description
     * @param supplyingPackingPlantCode supplying packing plant code
     * @param firstResult The first result
     * @param maxResults The max result
     */
    getAllActiveMaterials(numberOrDescription: string,
                          supplyingPackingPlantCode: string,
                          firstResult: number,
                          maxResults: number): Observable<MaterialDetailContract[]> {
        return this.http.get<MaterialDetailContract[]>(`${this.materialDetailActiveUrl}?` + [
            `numberOrDescription=${numberOrDescription}`,
            `supplyingPackingPlantCode=${supplyingPackingPlantCode}`,
            `firstResult=${firstResult}`,
            `maxResults=${maxResults}`
        ].join(('&')));
    }

    /**
     * This method retrieves all ai materials by number or description and supplying packing plant
     * @param numberOrDescription the number or description
     * @param supplyingPackingPlantCode supplying packing plant code
     * @param firstResult The first result
     * @param maxResults The max result
     */
    getAllAiMaterials(numberOrDescription: string,
                      supplyingPackingPlantCode: string,
                      firstResult: number,
                      maxResults: number): Observable<MaterialDetailContract[]> {
        return this.http.get<MaterialDetailContract[]>(`${this.materialDetailAiUrl}?` + [
            `numberOrDescription=${numberOrDescription}`,
            `supplyingPackingPlantCode=${supplyingPackingPlantCode}`,
            `firstResult=${firstResult}`,
            `maxResults=${maxResults}`
        ].join(('&')));
    }

    /**
     * This method retrieves the active ai materials by number or description and supplying packing plant
     * @param number the number
     * @param supplyingPackingPlantCode supplying packing plant code
     * @param firstResult The first result
     * @param maxResults The max result
     */
    getAllAiActiveMaterials(number: string,
                            supplyingPackingPlantCode: string,
                            firstResult: number,
                            maxResults: number): Observable<MaterialDetailContract[]> {
        return this.http.get<MaterialDetailContract[]>(`${this.materialDetailAiActiveUrl}?` + [
            `number=${number}`,
            `supplyingPackingPlantCode=${supplyingPackingPlantCode}`,
            `firstResult=${firstResult}`,
            `maxResults=${maxResults}`
        ].join(('&')));
    }
}
